export const documentTags = [
    {name: 'Foto', value: 'picture'},
    {name: 'Mitarbeiterfoto', value: 'picture-company'},
    {name: 'Sedcard', value: 'sedcard'},
    {name: 'Mitarbeiterausweis', value: 'employee-id'},
    {name: 'Personalausweis/Reisepass', value: 'id-card'},
    {name: 'Führerschein', value: 'license'},
    {name: 'Studiennachweis/Immatrikulationsbescheinigung', value: 'student-verification'},
    {name: 'Vertragsdokument', value: 'contract-document'},
    {name: 'Avatar', value: 'avatar'},
    {name: 'Sonstiges', value: 'other'}
]

export const tagToString = (tag: string) => documentTags.find(x => x.value === tag)?.name || 'Sonstiges';

export const documentWantsNumber = (tag: string) => ['employee-id', 'id-card', 'license', 'student-verification'].includes(tag)